import styled from 'styled-components';
import UnstyledTitle from '../../../../components/Title';

export const Title = styled(UnstyledTitle)`
    margin-top: 25px;
`;
